import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { StorageService } from "app/main/module/common/service/storage.service";
import { environment } from "environments/environment";
import { Globals } from "../../common/global";

@Injectable()
export class CasesService {
    public pageSubject: BehaviorSubject<number>;
    public pageObservable: Observable<number>;

    baseUrl = environment.baseUrl;

    apiUrl = this.baseUrl + "/api/v1/";
    latestEntry: any;
    startingEntry: any;
    ROWS = 10;

    orderBy = "dateTimeNum";
    currentPage = 0;

    constructor(
        public globals: Globals,
        private userService: StorageService,
        public httpClient: HttpClient
    ) {}

    getCases(page, perPage, status): Observable<any> {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        // // console.log(e);
        //   const headers = new HttpHeaders().set('Authorization', `${token}`);
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
        };
        const url = `${this.apiUrl}cases?lab_id=${lab_id}&page=${page}&per_page=${perPage}&filter=${status}`;
        return this.httpClient.get(url, httpOptions);
    }

    postCase(caseData): Observable<any> {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        const center = this.userService.getCookie("center");
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
        };
        const url = `${this.apiUrl}cases?lab_id=${lab_id}&center=${center}`;
        return this.httpClient.post(url, caseData, httpOptions);
    }

    getSingleCase(id): Observable<any> {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        // // console.log(e);
        //   const headers = new HttpHeaders().set('Authorization', `${token}`);
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
        };
        const url = `${this.apiUrl}cases?lab_id=${lab_id}&case_id=${id}`;
        return this.httpClient.get(url, httpOptions);
    }

    searchCase(searchText, page, perPage): Observable<any> {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        // // console.log(e);
        //   const headers = new HttpHeaders().set('Authorization', `${token}`);
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
        };

        const url = `${this.apiUrl}cases?lab_id=${lab_id}&search=${searchText}&page=${page}&per_page=${perPage}`;
        return this.httpClient.get(url, httpOptions);
    }

    updateCase(caseData, id): Observable<any> {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
        };
        const url = `${this.apiUrl}cases?lab_id=${lab_id}&case_id=${id}`;
        return this.httpClient.put(url, caseData, httpOptions);
    }

    getViewReminder() {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        const platForm = "web_app";
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
        };
        const url = `${this.apiUrl}reminders?lab_id=${lab_id}&platform=${platForm}`;
        return this.httpClient.get(url, httpOptions);
    }

    getReminderHistory(
        page: Number,
        perPage: Number,
        searchText?: string,
        selectedSatus?: string
    ) {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        const platForm = "web_app";
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
            params: new HttpParams()
                .set("lab_id", lab_id)
                .set("page", page.toString())
                .set("per_page", perPage.toString())
                .set("platform", platForm),
        };
        if (searchText) {
            httpOptions.params = httpOptions.params.set(
                "search",
                searchText.toLowerCase()
            );
        }
        if (selectedSatus && selectedSatus != "all") {
            const status =
                selectedSatus === "yetToReceive"
                    ? "Pending"
                    : selectedSatus === "yetToBook"
                    ? "Received"
                    : selectedSatus;
            httpOptions.params = httpOptions.params.set("filter", status);
        }
        return this.httpClient.get(
            `${this.apiUrl}reminders/history`,
            httpOptions
        );
    }

    getSingleViewReminder(id) {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        const platForm = "web_app";
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
        };
        const url = `${this.apiUrl}reminders?lab_id=${lab_id}&reminder_id=${id}`;
        return this.httpClient.get(url, httpOptions);
    }

    getSingleReminderHistory(id) {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        const platForm = "web_app";
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
        };
        const url = `${this.apiUrl}reminders/history?lab_id=${lab_id}&id=${id}`;
        return this.httpClient.get(url, httpOptions);
    }

    fetchPendingReminders() {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        const platForm = "web_app";
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
        };
        const url = `${this.apiUrl}reminders/history?lab_id=${lab_id}&platform=${platForm}&limit=1`;
        return this.httpClient.get(url, httpOptions);
    }

    updateReminder(
        reminderId: string,
        updates: {
            next_due_date?: string;
            status?: string;
            remark?: string;
            updated_by?: string;
            updated_on?: string;
        }
    ) {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        const platForm = "web_app";
        const data = {
            id: reminderId,
            update_data: {
                ...updates,
            },
        };
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
        };
        const url = `${this.apiUrl}reminders/history?lab_id=${lab_id}`;
        return this.httpClient.put(url, data, httpOptions);
    }
}
